import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { useUpdated } from "@common/lib/hooks";
import classNames from "classnames";
import * as React from "react";
import Content from "./Content/container";

import "./style.less";

export type MapProps = RootContainerProps & {
  isEditMode: boolean;
  isMobile: boolean;
  sourceId: string | null;
};

export interface ActionProps {
  init: () => void;
}

export default (props: ActionProps & MapProps) => {
  useUpdated(() => {
    props.init();
  }, [props.sourceId]);

  return (
    <Container
      className={classNames("cartly_content_leaderboard", { mobile: props.isMobile })}
      {...getContainerProps(props)}
    >
      {!!props.sourceId ? (
        <Content {...getRootContainerProps(props)} />
      ) : props.isEditMode ? (
        <span>The module isn't configured</span>
      ) : null}
    </Container>
  );
};
